<template>
	<div>
		<div class="col-md-4 pt-3 centre_sm_none" :class="{'d-sm-block':!specail&&(viewToggle||!clickToggle),'d-none':!specail&&(viewToggle||!clickToggle)}">
			<div class="right_list_content" :class="{'cur':!viewToggle}">
				<div style="line-height: 65px;">
					<p id="right_content_title_information" class="pl-3 mb-0">
						<i class="fa fa-file-text-o fa-lg mr-2"></i>Real-time Info
                        <button class="btn genceback float-right mt-3" @click="reset">Reset</button>
					</p>
				</div>
				<div>
					<div class="d-flex flex-wrap right_information_dropdown">

						<!--<div class="text-muted flex-fill col-4 m-0 ">
							<div class="dropdown">
								<li class="dropdown-toggle" data-toggle="dropdown">
									<span class="beyond_one">{{this.nationsSelected}}</span>
								</li>
								<div class="dropdown-menu nano statenano" style="height: 470px;">

									<div class="nano-content nano-contents">

										<a class="dropdown-item" v-for="(value, key) in nations" @click="filtrateState(value)" href="javascript:">{{value}}</a>

									</div>
								</div>
							</div>
						</div>-->
						<div class=" text-muted flex-fill col-6 m-0 ">
							<div class="dropdown">
								<li class="dropdown-toggle" data-toggle="dropdown">
									<span class="beyond_one">{{this.classifysSelected}}</span>
								</li>
								<div class="dropdown-menu nano" style="height: auto;width: 195px;">

									<div class="nano-content nano-contents">
										<a class="dropdown-item" v-for="(value, key) in classifys" @click="filtrateClassifys(value)" href="javascript:">{{value}}</a>
									</div>
								</div>
							</div>
						</div>
						<div class=" text-muted flex-fill col-6 m-0 ">
							<div class="dropdown">
								<li class="dropdown-toggle" data-toggle="dropdown">
									<span class="beyond_one">{{this.industrysSelected}}</span>
								</li>
								<div class="dropdown-menu nano" style="height: auto;width: 300px;">

									<div class="nano-content nano-contents">
										<a class="dropdown-item" v-for="(value, key) in industrys" @click="filtrateindustry(key,value)" href="javascript:">{{value}}</a>
									</div>

								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="row nano video_breviary m-0 information_list wenzlist">
					<div class="nano-content" id="home_right_list">
						<ul class="list-unstyled">

							<li v-for="(probation,index) in probations" v-if="probations" class="media pb-4 pt-4 pl-4 pr-3 border-bottom probation_back " :key="index">

								<img v-if="probation.thumb!=''" class="mr-3 img-thumbnail probations_img" :src="probation.thumb" />
								<div class="media-body">
									<h5>
										<router-link class="f15 text-dark font-weight-bold" :value="probation.id" :to ="{name:'articleId',params :{contentid:probation.id}}">{{ probation.title }}</router-link>
									</h5>
									<div class="clearfix" style="line-height: 22px;">
										<div class="float-left">
											<span class="border border-primary text-primary f12 p11" @click="filtrateClassifys(probation.catName)"><a href="javascript:">{{ probation.catName }}</a></span>
										</div>
										<div class="float-left pr-3 pl-3" v-if="probation.description">
											<img src="../../../assets/images/silkRoadBase/Vertical_barsm.png" />
										</div>
										<div class="float-left" v-if="probation.description">
											<span class="f12 text-muted">{{timeDiff(probation.published)}}</span>
										</div>
									</div>
								</div>
							</li>

							<li v-for="homeList in homeLists" class="media pb-4 pt-4 pl-4 pr-3 border-bottom">

								<img v-if="homeList.thumb!=''" class="mr-3 img-thumbnail probations_img" :src="subImage(homeList.thumb)" />
								<div class="media-body">
									<h5>
										<router-link class="f15 text-dark font-weight-bold" :to ="{name:'articleId',params :{contentid:subContentId(homeList.resourceId)}}">{{ homeList.title }}</router-link>
									</h5>

									<div  class="media-foot f13 mt-3 mb-3 font-weight-light text-muted">
										<span>{{ homeList.description}}</span>
									</div>

									<div class="clearfix" style="line-height: 22px;">
										<div class="float-left">
											<span class="border border-primary text-primary f12 p11" @click="filtrateClassifys(homeList.catName)"><a href="javascript:">{{ homeList.catName }}</a></span>
										</div>
										<div class="float-left pr-3 pl-3" v-if="homeList.description">
											<img src="../../../assets/images/silkRoadBase/Vertical_barsm.png">
										</div>
										<div class="float-left" v-if="homeList.description">
											<span class="f12 text-muted">{{timeDiff(homeList.published)}}</span>
										</div>
									</div>
								</div>
							</li>
							<p class="text-center" v-if="loadShow"><i class="fa fa-spinner fa-pulse fa-2x mt-3"></i></p>
						</ul>
                        <div v-if="endShow" class="w-100">
                            <p class="text-center p-2">loading....</p>
                        </div>
                        <div v-if="homeLists.length ==0&&probations.length==0&&!loadShow" class="nodata text-center">
                            <img src="../../../assets/images/silkRoadBase/no_data.png" class="mt100"  alt="">
                            <p class="text-center p-2">Data unavailable</p>
                        </div>
					</div>
				</div>

			</div>
		</div>
		<div class="col-md-8 pl-0 mt-3 centre_sm_none" :class="{'d-sm-block':!specail&&(viewToggle||clickToggle),'d-none':!specail&&(viewToggle||clickToggle)}">


			<articles></articles>


		</div >

	</div>
</template>
<script>
	import articles from './ArticleDetails/Article.vue'
	export default({
		name: 'information',

		data: function() {
			return {
                loadShow:true,
				nations: [],
				classifys: [],
				industrys: [],
				homeLists: [],
				probations: [], //试读
				industryTexts: [],
				classifysTexts: [],
				nationsTexts: [],
				nationsSelected: 'Global',
				classifysSelected: 'All news',
				industrysSelected: 'All industries',
				industryID: '0', //分类ID
				page: 0,
                specail:false, //特殊处理 小于544px
				total_page: 1,
				probationes: [],
				//				detailes: [],
				firstlist: '',
				token: '',
                viewToggle:true,
                clickToggle:true,
                endShow:false
			}
		},
		created: function() {
			var self = this;
			let that = this;
//            this.loadShow=true;
            if(this.IsPC()&&(document.body.clientWidth<=700)){
                this.specail=true
            }else{
                this.specail=false
            }
            this.viewToggle=this.IsPC();
            this.$axios.post('/api/pc/getquery', {
                id: this.$route.params.id
            }).then(data => {
                var classifys = data.data.data.classify; //分类
                self.classifys = classifys;
                /*self.classifys = ["政治外交","经济发展","产业投资","投资建议","经济发展","投资政策","贸易往来","社会文化"];*/
                //self.classifysSelected = data.data.data.category_name;
                self.loadShow = false;
				var classify = self.classifysSelected;
				if(classify=='All news'){
					classify = '英文资讯';
				}
                //首页左侧列表请求
                this.$axios({
                    url: 'https://recommend.imsilkroad.com/recommend/rest/tag/2/0/0/0/' + encodeURI(classify) + '/0',
                    method: 'get',
                    headers: {
                        token: that.token
                    }
                }).then(data => {
//                    this.loadShow=false;
                    var homeLists = data.data.results;
                    self.token = data.data.token;
                    self.homeLists = homeLists;
                    self.total_page = data.data.totalPage;
                    // 加载子路由
                    self.$router.push({
                        name: 'articleId',
                        params: {
                            contentid: this.$route.params.contentid ? this.$route.params.contentid : self.subContentId(homeLists[0].resourceId)
                        }
                    });

                },function (error) {
//                    this.loadShow=false;
                })
            },function (error) {
//                this.loadShow=false;
            })


			//首页左侧试读列表请求
			this.$axios.post('/api/pc/gettryreadarticle', {
				id: this.$route.params.id
			}).then(data => {
				var probations = data.data.data;
				that.probations = probations;
			})

			//请求select框
			this.$axios.post('/api/pc/getquery').then(data => {
				var nations = data.data.data.nation; //国家
				var industrys = data.data.data.industry; //行业
				self.nations = nations;
				self.industrys = industrys;
			})


		},

		mounted() {
			document.getElementById('home_right_list').addEventListener('scroll', this.handleScroll);
			this.load();
		},
		methods: {
            goback(){
                if(this.viewToggle){
                    this.$router.push({name:'consult_particulars_organization',params :{id:"10",type:1}})
                }else{
                    this.clickToggle=true;
                }

            },
            clickToggles(){
                this.clickToggle=false;
            },
			filtrateState: function(e) { //国家
				this.reveal = true;
				let that = this;
				that.nationsSelected = e;

				var column = encodeURI(e); //全部国家
				var classify = encodeURI(that.classifysSelected); //全部分类
				var industry = that.industryID; //全部行业
				if(e == 'Global') {
					column = 0;
				}
				if(that.classifysSelected == 'All news') {
					classify = encodeURI('英文资讯');
				}
				this.$axios({
					url: 'https://recommend.imsilkroad.com/recommend/rest/tag/2/0/0/' + column + '/' + classify + '/' + industry,
					method: 'get'
				}).then(data => {
					that.homeLists = data.data.results;
					that.token = data.data.token;
					that.total_page = data.data.totalPage;
				}, function(response) {
					console.info(response);
					if(response) {
						console.log("失败");
					}
				})
			},
			filtrateClassifys: function(e) { //分类
				this.reveal = true;
				let that = this;
				that.classifysSelected = e;
				var column = encodeURI(that.nationsSelected); //全部国家
				var classify = encodeURI(e); //全部分类
				var industry = that.industryID; //全部行业
				if(that.nationsSelected == 'Global') {
					column = 0;
				}
				if(e == 'All news') {
					classify = encodeURI('英文资讯');
				}
				this.$axios({
					url: 'https://recommend.imsilkroad.com/recommend/rest/tag/2/0/0/' + column + '/' + classify + '/' + industry,
					method: 'get'
				}).then(data => {
					that.homeLists = data.data.results;
					that.token = data.data.token;
					that.total_page = data.data.totalPage;
				}, function(response) {
					console.info(response);
					if(response) {
						console.log("失败");
					}
				})
			},
			filtrateindustry: function(e, val) { //行业
				this.reveal = true;
				let that = this;
				var column = encodeURI(that.nationsSelected); //全部国家
				var classify = encodeURI(that.classifysSelected); //全部分类
				var industry = e; //全部行业
				that.industryID = e;
				that.industrysSelected = val;
				if(that.nationsSelected == 'Global') {
					column = 0;
				}
				if(that.classifysSelected == 'All news') {
					classify = encodeURI('英文资讯');
				}
				this.$axios({
					url: 'https://recommend.imsilkroad.com/recommend/rest/tag/2/0/0/' + column + '/' + classify + '/' + industry,
					method: 'get'
				}).then(data => {
					that.homeLists = data.data.results;
					that.token = data.data.token;
					that.total_page = data.data.totalPage;
				}, function(response) {
					console.info(response);
					if(response) {
						console.log("失败");
					}
				})
			},
			handleScroll() {
				var industry;
				var column;
				var classify;
				if(this.nationsSelected == 'Global') {
					column = 0;
				} else {
                    column = this.nationsSelected;
                }
				if(this.classifysSelected == 'All news') {
					classify = encodeURI('英文资讯');
				} else {
                    classify = this.classifysSelected;
                }
				if(this.industrysSelected == 'All industries') {
					industry = 0;
				} else {
                    industry = this.industryID;
                }
				var top = document.getElementById('home_right_list').scrollTop; // 滚动条到上面的距离
				var client = document.getElementById('home_right_list').clientHeight; // 可视区域的高度
				var all = document.getElementById('home_right_list').scrollHeight; // 总高度
				if(((all - 20) < (top + client)) && !this.loadShow) {
					this.page++;
					if(this.page > this.total_page) {
					    this.endShow = true;
						return;
					}
					this.loadShow = true;
                    var self = this;
					this.$axios({
						url: 'https://recommend.imsilkroad.com/recommend/rest/tag/2/0/' + this.page + '/' + column + '/' + classify + '/' + industry,
						method: 'get',
						headers: {
							token: self.token
						}

					}).then(data => {
						var homeListes = data.data.results;
						JSON.stringify(homeListes);
						self.token = data.data.token;
						var new_homeLists = self.homeLists.concat(homeListes);
						self.homeLists = new_homeLists;
						self.total_page = data.data.totalPage;
						self.loadShow = false;
					}, function(response) {
						console.info(response);
					})
				}

			},
			timeDiff(published) {
                var now = new Date();
                var date3 = now.getTime() - published;

                // 计算相差年数
                var years =  Math.floor(date3 / (356 * 24 * 3600 * 1000))
                //计算出相差天数
                var days = Math.floor(date3 / (24 * 3600 * 1000))
                //计算出小时数
                var hours = Math.floor(date3 / (3600 * 1000))
                //计算相差分钟数
                var minutes = Math.floor(date3 / (60 * 1000))
                // 计算相差秒数
                var seconds = Math.floor(date3 / 1000)

                if (years > 0) {
                    var time = new Date(published);
                    var y = time.getFullYear();
                    var m = time.getMonth()+1;
                    var d = time.getDate();
                    return y + '-' + m + '-' + d;
                }

				if(days > 0) {
					if (days > 7) {
						var time = new Date(published);
						var m = time.getMonth()+1;
						var d = time.getDate();
						return m + '-' + d;
					} else {
						if(days==1){
							return days + 'day ago';
						}
						return days + 'days ago';
					}
				}

				if(hours > 0) {
					if(hours==1){
						return hours + 'hour ago';
					}
					return hours + 'hours ago';
				}

				if(minutes > 0) {
					if(minutes==1){
						return minutes + 'minute ago';
					}
					return minutes + 'minutes ago';
				}
				if (seconds > 0) {
					if(seconds==1){
						return  seconds + 'second ago';
					}
					return  seconds + 'second ago';
				}
			},
            subContentId(contentid) {
                // 查找 站点是否存在
                var start = contentid.indexOf('_');

                if (start > 0) {
                    var arr = contentid.split('_');
                    return arr[1];
                } else {
                    return contentid;
                }

            },
            reset:function() {
			    var that = this;
                that.nationsSelected = 'Global';
                that.classifysSelected = 'All news';
                that.industrysSelected = 'All industries';
                //首页左侧列表请求
                var classify = encodeURI('英文资讯');
                this.$axios({
                    url: 'https://recommend.imsilkroad.com/recommend/rest/tag/2/0/0/0/' + classify + '/0',
                    method: 'get',
                    headers: {
                        token: that.token
                    }
                }).then(data => {
                    var homeLists = data.data.results;
                    that.token = data.data.token;
                    that.homeLists = homeLists;
                    that.total_page = data.data.totalPage;
                    that.$router.push({
                        name: 'articleId',
                        params: {
                            contentid: self.subContentId(homeLists[0].resourceId)
                        }
                    });

                })
            },
            subImage(thumb) {
                // 处理组图的显示
                var start = thumb.indexOf('|');

                if (start > 0) {
                    var arr = thumb.split('|');
                    return arr[1];
                } else {
                    return thumb;
                }
            }
		},
        computed: {
            isFollow () {
                return this.$store.state.screenWidth;
            }
        },
		watch: {
			$route: {
				handler: function(val, oldVal) {
					var self = this;
					let that = this;

					if(this.$route.params.contentid) {

					} else {
						this.$axios.post('/api/pc/gettryreadarticle', {
							id: this.$route.params.id
						}).then(data => {
							var probations = data.data.data;
							self.probations = probations;

							//首页左侧列表请求
							var classify = encodeURI('英文资讯');
							this.$axios({
								url: 'https://recommend.imsilkroad.com/recommend/rest/tag/2/0/0/0/' + classify + '/0',
								method: 'get',
								headers: {
									token: that.token
								}
							}).then(data => {
								var homeLists = data.data.results;

								if(that.probations == '') {

									that.$router.push({
										name: 'articleId',
										params: {
											contentid: homeLists[0].resourceId,
										}
									});
								} else {
									that.$router.push({
										name: 'articleId',
										params: {
											contentid: probations[0].id,
										}
									});
								}

							})
						})
					}

				},
				deep: true
			},
            isFollow (val) {
                if (!this.timer) {
                    //this.screenWidths = val;
                    this.timer = true;
                    let that = this;
                    setTimeout(function () {
                        if(that.IsPC()&&(val<=700)){
                            that.specail=true
                        }else{
                            that.specail=false
                        }
                        that.timer = false
                    }, 300)
                }

            }
		},
		components: {
			articles
		}
	})
</script>
<style scoped type="text/css">
    .nano > .nano-contents{
        position:relative;
        max-height:440px;
        margin: auto!important;
    }
    #home_right_list.cur{
        position: absolute;
        overflow: scroll;
        overflow-x: hidden;
        bottom: 0;
        height: inherit;
    }
</style>
